import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import joinCut from "standard/joinCut";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import style from "./style";

@define("m-check")
class Avaliation extends HTMLElement {
  #opened;
  #student;
  #question;
  #criterion;

  get [trait.opened]() {
    return (this.#opened ??= false);
  }

  get [trait.question]() {
    return (this.#question ??= {});
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <aside class="${style.modal}" opened=${this[trait.opened]}>
        <section class="${style.modal__container}">
          <header class="${style.modal__header}">
            <img class="${style.modal__img}" alt="Avatar">
            <hgroup class="${style.modal__hgroup}">
              <h1>${this.#student?.name}</h1>
              <h2>3º ano &bull; Alpha</h2>
            </hgroup>
          </header>
          <main class="${style.modal__main}">
            ${this.#criterion
              ?.map(
                (data) => `
              <section class="${style.modal__section}">
                <div>
                  <strong class="${style.modal__strong}">${data.criterion.titulo}</strong><br />
                  <span class="${style.modal__span}">${data.description}</span>
                </div>
                <ul class="${style.modal__ul}">
                  <li data-question="${data.id}" data-answer="1" checked="${this[trait.question][data.id] == 1}" class="${style.modal__li}">Sim</li>
                  <li data-question="${data.id}" data-answer="0" checked="${this[trait.question][data.id] == 0}" class="${style.modal__li}">Não</li>
                </ul>
              </section>
            `,
              )
              .join("")}
          </main>
          <footer class="${style.modal__footer}">
            <button class="${style.modal__save}">Salvar avaliação</button>
          </footer>
        </section>
      </aside>
    `;
  }

  @on.click(`li.${style.modal__li}`)
  @repaint
  [trait.check](event) {
    const { question, answer } = event.target.dataset;
    Object.assign(this[trait.question], { [question]: answer });
    return this;
  }

  @connected
  [trait.addEventListener]() {
    window.addEventListener("check:open", this[trait.open].bind(this));
    return this;
  }

  @repaint
  async [trait.open](event) {
    const { data } = await supabase
      .from("user")
      .select("*")
      .eq("id", event.detail)
      .single();

    const { data: criterion } = await supabase
      .from("activity_criterion")
      .select("*, criterion(*)")
      .eq("activity_id", this.dataset.activity);

    this.#criterion = criterion;
    this.#student = data;
    this.#opened = true;
    this.#question = {};
    return this;
  }

  @on.click(`aside.${style.modal}`)
  @repaint
  [trait.close]() {
    this.#opened = false;
    return this;
  }

  @on.click(`button.${style.modal__save}`)
  @joinCut(trait.close)
  async [trait.save]() {
    await supabase.from("activity_corrected").insert(
      this.#criterion?.map((criterion) => ({
        activity_criterion_id: criterion.id,
        student_id: this.#student.id,
        educator_id: this.dataset.educator,
        answer: this[trait.question][criterion.id] ?? 0,
        date: new Date().getTime(),
      })),
    );

    location.reload();
    return this;
  }
}

export default Avaliation;
